<template>
  <div class="column scoped no-wrap full-width bg-white">
    <div
      class="row q-pa-smd no-wrap items-center justify-start"
      style="flex-shrink: 0"
    >
      <img
        alt="Source logo"
        class="logo"
        :src="segment.source.logo_url"
      />
      <div class="column">
        <strong v-if="segment.program_airing && segment.program_airing.name">
          {{ segment.program_airing.name }}
        </strong>

        <span class="bold">
          <QIcon name="ion-md-time" />
          {{ formattedSegmentStartTime }}

          ({{ segment.source.time_zone }})
        </span>
      </div>
    </div>
    <div class="q-pa-sm">
      <strong>{{ segment.title }}</strong>
    </div>
    <InlinePlayer
      :clip="segment"
      :mention="segment"
      :poster="thumbnail"
      type="video"
    />
  </div>
</template>

<script>
import InlinePlayer from "shared/components/players/InlinePlayer.vue";
import { formatIntlDate } from "shared/helpers/date";

export default {
  name: "TvSegmentPreview",
  components: {
    InlinePlayer,
  },
  props: {
    segment: {
      type: Object,
      required: true,
    },
  },
  computed: {
    thumbnail() {
      return this.segment.thumbnails[0].url;
    },
    formattedSegmentStartTime() {
      return formatIntlDate(this.segment.start_time * 1000, {
        day: "numeric",
        month: "short",
        hour: "numeric",
        minute: "numeric",
        timeZone: this.segment.source.time_zone,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  width: 40px;
  margin-right: 15px;
}

.q-icon {
  vertical-align: 0;
}

.scoped:deep(em) {
  background-color: rgb(252 220 89 / 30%);
  padding: 1px 2px;
  font-style: normal;
}
</style>
